export class ValidationErrorLevels {
// eslint-disable-next-line sonarjs/public-static-readonly
    static error = "error";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static warning = "warning";
}
